module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/plan01_beach-photo-eaba9c2624ed056986d7177a530c57be.jpg";